export function extractPageTopics(metadata: unknown): { left: string; right: string } {
  const empty = { left: '', right: '' }
  const rec = (v: unknown) =>
    v && typeof v === 'object' && !Array.isArray(v) ? (v as Record<string, unknown>) : null
  const str = (v: unknown) => (typeof v === 'string' ? v : '')

  const m = rec(metadata)
  // NsDocument from the API - the sole source of checkpoint document structure.
  const nsDoc = rec(m?.nsDocument) ?? rec(m?.NsDocument)
  const meta = rec(nsDoc?.spreadMetaInfo) ?? rec(nsDoc?.SpreadMetaInfo)
  const ladder = rec(meta?.ladderInfo) ?? rec(meta?.LadderInfo)
  const pages = rec(ladder?.pages) ?? rec(ladder?.Pages)

  if (!pages) return empty

  const lp = rec(pages.leftPage) ?? rec(pages.LeftPage)
  const rp = rec(pages.rightPage) ?? rec(pages.RightPage)

  return {
    left: str(lp?.topic ?? lp?.Topic),
    right: str(rp?.topic ?? rp?.Topic),
  }
}
